__turbopack_context__.v({
  "proseColumn": "ProseColumn-module__RKL6EW__proseColumn",
});
